import { Controller } from "stimulus"
import PrescreenNotificationModule from "./shared_modules/prescreen_notification_module.js"

export default class extends Controller {
  static values = {
    message: { type: String, default: "Are you sure?" },
    title: { type: String, default: "Are you sure?" }
  }

  connect() {
    this.notifications = new PrescreenNotificationModule()
  }

  confirm(event) {
    event.preventDefault()
    event.stopPropagation()

    const url = this.element.getAttribute("href")
    if (!url) return

    this.notifications
      .confirmDelete({
        title: this.titleValue,
        message: this.messageValue
      })
      .then((result) => {
        if (!result.isConfirmed) return

        const token = document.querySelector('meta[name="csrf-token"]')?.content
        fetch(url, {
          method: "DELETE",
          credentials: "same-origin",
          headers: {
            "X-CSRF-Token": token,
            Accept: "text/html, application/xhtml+xml",
            "X-Requested-With": "XMLHttpRequest"
          },
          redirect: "follow"
        }).then((response) => {
          if (response.redirected) {
            Turbolinks.visit(response.url)
          } else if (response.ok) {
            Turbolinks.visit(window.location.href)
          } else {
            this.notifications.error("Could not complete delete. Check for related records and try again.")
          }
        }).catch(() => {
          this.notifications.error("Could not complete delete. Please try again.")
        })
      })
  }
}
